import React, { useState } from "react";
import { Link } from "@mui/material";

import { getFormattedDate } from "utils/date";
import { DISCONNECT_HISTORY_VISIBLE_COUNT } from "static/constants";
import { sortStatusesNewestFirst } from "components/pages/transmissions/modal/patient/tabs/subscription/disconnectHistory/useDisconnectHistory";

const EarlierStatuses = ({ statuses }) => {
  const [expanded, setExpanded] = useState(false);
  const hiddenCount = Math.max(
    statuses.length - DISCONNECT_HISTORY_VISIBLE_COUNT,
    0
  );
  // Newest first by date.
  const ordered = sortStatusesNewestFirst(statuses);
  const shown =
    expanded || hiddenCount === 0
      ? ordered
      : ordered.slice(0, DISCONNECT_HISTORY_VISIBLE_COUNT);

  return (
    <>
      Earlier:{" "}
      {shown
        .map(
          (entry) =>
            `${entry?.status || "no reason given"} (${getFormattedDate(
              entry?.recorded_at,
              "MM/DD/YYYY"
            )})`
        )
        .join(", ")}
      .
      {hiddenCount > 0 && (
        <Link
          component="button"
          type="button"
          underline="none"
          color="secondary"
          sx={{
            ml: 1,
            p: 0,
            font: "inherit",
            lineHeight: "inherit",
            verticalAlign: "baseline",
          }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "See less" : `See ${hiddenCount} earlier`}
        </Link>
      )}
    </>
  );
};

export default EarlierStatuses;
